
exports.Treemap = require('./Treemap');



//////////////////
// WEBPACK FOOTER
// ./~/react-d3/treemap/index.js
// module id = 369
// module chunks = 0